import { teamRepo } from "@/repositories/teamRepo";
import { useObservable } from "@repo/ui/components/Base/hooks/useObservable";

export const useGetTeam = (tenantId: string, teamId: string) => {
  return useObservable(
    () => teamRepo.get(tenantId, teamId),
    [tenantId, teamId]
  );
};

export const useTeamList = (tenantId: string) => {
  return useObservable(() => teamRepo.list(tenantId), [tenantId]);
};
